export default class ActionType {

    static HARVEST = 'Harvest';
    static FISHING_AUCTION = 'FishingAuction';
    static SAMPLE = 'Sample';
    static SOWING = 'Sowing';
    static TREATMENT = 'Treatment';
    static TREATMENT_SOWING = 'TreatmentSowing';
    static TREATMENT_HARVEST = 'TreatmentHarvest';
}
